import * as sfx from '../pages/labs/launchSound.js';
import { canSpeak, speak, hush } from './speech.js';

/**
 * The noise a passed quiz makes.
 *
 * A short fanfare, then Cub saying well done. Deliberately in that
 * order and with a gap between them: a voice competing with a chord is
 * a voice nobody understands.
 *
 * On by default, unlike everything else that makes a sound here. The
 * rest of the audio in this app is opt-in because it runs for minutes
 * at a time in a room full of machines; this is two seconds, it happens
 * once, and it only ever follows a child pressing a button. Turning it
 * off is one click on the results screen and is remembered after that.
 */

const KEY = 'cybercub.celebrate';

export const isOn = () => {
  try {
    return localStorage.getItem(KEY) !== 'off';
  } catch {
    return true;
  }
};

export const setOn = (on) => {
  try {
    localStorage.setItem(KEY, on ? 'on' : 'off');
  } catch {
    /* private window - the choice lasts for this visit only */
  }
};

/**
 * Wake the audio engine while a click is still in progress.
 *
 * Browsers only allow audio to start inside a user gesture, and the
 * quiz is graded on the server - by the time the result comes back the
 * gesture has long finished. So this is called first, synchronously,
 * from the button handler.
 */
export function arm() {
  if (!isOn()) return;
  sfx.wake();
}

/* A few, so a child working through a module does not hear the same
   sentence nine times. */
const PASSED = [
  'Well done! You passed.',
  'Nice work. That is a pass.',
  'You got it. Well done!',
];

const PERFECT = [
  'Perfect! Every single one right.',
  'Full marks! Not one wrong.',
  'Every question right. Brilliant.',
];

const pick = (list) => list[Math.floor(Math.random() * list.length)];

/**
 * Play it. Safe to call when sound is off, when the browser has no
 * speech, or when the audio engine never woke - each of those just
 * means a quieter celebration, not an error.
 */
export function play({ perfect = false, badges = [], voice = null } = {}) {
  if (!isOn()) return;

  sfx.play('fanfare');

  if (!canSpeak()) return;

  let line = perfect ? pick(PERFECT) : pick(PASSED);
  if (badges.length === 1) line += ` You earned the ${badges[0].title} badge.`;
  else if (badges.length > 1) line += ` You earned ${badges.length} new badges.`;

  // After the fanfare, not over it.
  setTimeout(() => {
    if (isOn()) speak(line, voice);
  }, 1100);
}

/** Stop mid-celebration, for turning it off or leaving the page. */
export function stop() {
  hush();
}
